import { action, computed, observable } from 'mobx';
import Alert from 'react-s-alert';
import i18next from 'i18next';

import { AppManager, Variables, Input } from 'core';
import { analytics } from 'core/analytics';
import { ProfileModel, ProfileApp } from 'apps/profile/app';
import { ProfileSpaceQuery } from 'apps/home/pricing/gql';
import { clientStore } from 'apps/client/app';
import { CreateSubscriptionMutation } from 'apps/payment/gql';

export class PricingAppManager extends AppManager {
  static registryName = 'PricingAppManager';
  @observable loading = false;

  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('profile', ProfileApp);
    this.variables = new Variables({
      username: () =>
        clientStore.signedInProfile && clientStore.signedInProfile.username,
    });
    this.NewProfileSpaceQuery();
    this.onSuccessCb = init.onSuccess;
  }

  @action NewProfileSpaceQuery = () => {
    const q = new ProfileSpaceQuery(this, {
      queryKey: 'profile',
      onSysErr: this.onProfileError,
    });
    q.process(profile => ProfileModel.Load(profile), this.ProfileUpdate);
    q.query();
  };

  @action ProfileUpdate = profileModel => {
    this.profile = profileModel;
  };

  onSuccess = () => {
    analytics.sendEvent('start-free-trial', {
      space: this.profile?.username,
    });
    analytics.sendEvent(
      'StartTrial',
      { value: 7, currency: 'EUR' },
      { twitter: true, facebook: true },
    );
    this.SetIsLoading(false);
    this.NewProfileSpaceQuery();
    Alert.success(
      i18next.t('Successfully started your 30 day free trial. Enjoy!'),
    );

    if (this.onSuccessCb) {
      this.onSuccessCb();
    }
  };

  onError = () => {
    this.SetIsLoading(false);
    Alert.error(
      i18next.t("We couldn't start your free trial. Try again later"),
    );
  };

  @action StartFreeTrial = () => {
    this.SetIsLoading(true);
    const spacePrefix =
      this.profile.inSpace.spaceType === 'PROFILE' ? '@' : '+';
    const subscriptionInput = new Input({
      spaceSlug: () => spacePrefix + this.profile.inSpace.content.slug,
      startFreeTrial: () => true,
      countryCode: () => '',
    });
    const mutation = CreateSubscriptionMutation.New(subscriptionInput, {
      onSysErr: this.onError,
      onUserErr: this.onError,
      onSuccess: this.onSuccess,
    });
    return mutation;
  };

  @action SetIsLoading(loading) {
    this.loading = loading;
  }

  @computed get isLoading() {
    return this.loading;
  }
}
